import React, { ElementType } from 'react';
import { Center, Text, useColorModeValue } from '@chakra-ui/react';

import { createCirclePercentageFilledIcon } from '../../../../styles/create-circle-percentage-filled-icon';

export function DeviceIcon({ Icon, title, subtitle }: { Icon?: ElementType; title?: string; subtitle?: string }) {
  const iconColor = useColorModeValue('primaryBranding.600', 'primaryBranding.200');
  const CircleIcon = createCirclePercentageFilledIcon(100);

  return (
    <>
      {!!Icon && (
        <Center position="relative" px={3} flexDirection="column" textAlign="center" mt={8}>
          <Icon w={[100, 130, 150]} h={[100, 130, 150]} color={iconColor} pos="absolute" data-testid="status-icon" />
          <CircleIcon w={[220, 290, 330]} h={[220, 290, 330]} color={iconColor} data-testid="circle-icon" zIndex={3} />
        </Center>
      )}
      {!!title && (
        <Text textAlign={'center'} fontSize={24} data-testid="device-name" mt={4}>
          {title}
        </Text>
      )}
      {!!subtitle && (
        <Text textAlign={'center'} data-testid="device-subtitle" mt={4}>
          {subtitle}
        </Text>
      )}
    </>
  );
}
